type RemoveAllocationError = {
  notFound: boolean;
};

const removeAllocationError: RemoveAllocationError = {
  notFound: false,
};

export type { RemoveAllocationError };

export { removeAllocationError };
